﻿import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import definitions from '../../../Style/LfStyleDefinitions';
import { mediaQuery } from '../../../Style/cssHelpers';

class HealthDeclarationHeading extends React.Component {
    render() {
        const registration = this.props.data.healthDeclarationRegistration;
        let name = '';

        if (registration.targetGroupName == 'djur') {
            name = registration.animalGivenName;
        } else if (!registration.appliesToCoinsured) {
            name = `${this.props.data.customer.firstName} ${this.props.data.customer.lastName}`;
        } else if (typeof this.props.data.coinsuredInfo !== 'undefined' &&
            this.props.data.coinsuredInfo &&
            this.props.data.coinsuredInfo.firstName &&
            this.props.data.coinsuredInfo.lastName)
        {
            name = `${this.props.data.coinsuredInfo.firstName} ${this.props.data.coinsuredInfo.lastName}`;
        }

        return (
            <HealthDeclarationHeadingWrapper>
                <h4>{registration.displayName}</h4>
                {name}
            </HealthDeclarationHeadingWrapper>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageData
    };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HealthDeclarationHeading);

// styles

const HealthDeclarationHeadingWrapper = styled.div`
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 400;
    font-family: ${definitions.fonts.main};

    ${mediaQuery.medium(`
        padding-top: 10px;
    `)}

    ${mediaQuery.small(`
        padding-top: 0;
        font-size: 16px;
        h4 {
            font-size: 20px;
            margin: 5px 0px 10px 0px;
        }
    `)}

    ${mediaQuery.xxsmall(`
        padding-top: 0;
        font-size: 13px;
        h4 {
            font-size: 16px;
        }
    `)}
`;
